(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
var brand_logos = $("#client-car");
brand_logos.owlCarousel({
items:6,
loop:false,      
dots: false, 
nav:true,
navContainer:".nav_brand_type",
navText: ['<a class="prev"><i class="fa fa-angle-left" aria-hidden="true"></i></a>','<a class="next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>'],
autoplay: true,
autoplayTimeout: 3000,
responsive:{
0:{
items: 1
},
600:{
items:2
},
700:{
items:4
},
1024:{
items:4
},
1200:{
items: 4
}
}
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-type-5"]) return;
  try {
    
function setHeaderTopCookie() {
document.cookie = "headerTop=closed; path=/; max-age=31536000";
}

function getHeaderTopCookie() {
return document.cookie.indexOf('headerTop=closed') !== -1;
}

function hideHeaderTop(immediate) {
var headerTop = document.getElementById('HeaderAnnouncementBar');
var headerWrap = document.querySelector('.header-type-5');
if (headerTop) {
if (headerWrap) {
headerWrap.classList.add('header-announcement-hidden');
}
if (immediate) {
headerTop.classList.remove('is-closing');
headerTop.setAttribute('hidden', 'hidden');
headerTop.style.display = 'none';
return;
}

if (headerTop.classList.contains('is-closing')) {
return;
}

headerTop.classList.add('is-closing');
window.setTimeout(function() {
headerTop.setAttribute('hidden', 'hidden');
headerTop.style.display = 'none';
headerTop.classList.remove('is-closing');
}, 360);
}
}

window.handleHeaderAnnouncementClose = function(event) {
if (event) {
event.preventDefault();
if (event.stopPropagation) {
event.stopPropagation();
}
}

hideHeaderTop(false);
setHeaderTopCookie();
return false;
};

if (getHeaderTopCookie()) {
hideHeaderTop(true);
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-sidebar-deals"]) return;
  try {
    
 (function() {
   var initAttempts = 0;

   function initHomeSidebarDeals() {
     if (typeof jQuery === 'undefined' || !jQuery.fn || !jQuery.fn.owlCarousel) {
       if (initAttempts < 40) {
         initAttempts += 1;
         window.setTimeout(initHomeSidebarDeals, 250);
       }
       return;
     }

     var homeSidedeals = jQuery(".sidebar-deal-products");
     if (!homeSidedeals.length || homeSidedeals.hasClass('owl-loaded')) {
       return;
     }

     homeSidedeals.owlCarousel({
       items:1,
       loop:true,
       dots: false,
       navContainer: ".home_sidebar--deal-nav",
       navText: [' <a class="prev active btn"><i class="icon-arrow-left icons"></i></a>','<a class="next btn"><i class="icon-arrow-right icons"></i></a>']
     });
   }

   if (document.readyState === 'loading') {
     document.addEventListener('DOMContentLoaded', initHomeSidebarDeals);
   } else {
     initHomeSidebarDeals();
   }

   window.addEventListener('load', initHomeSidebarDeals);
 })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sidebar-promoimage"]) return;
  try {
    
$(document).ready(function(){
     $("#promo-carousel").owlCarousel({ 
      autoPlay: 3000, //Set AutoPlay to 3 seconds 
        items: 1,
        itemsCustom: false,
        itemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false,
        pagination:true
 
  });
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-category"]) return;
  try {
    
$(document).ready(function(){
  $(".widget_product_categories .category-sidebar-toggle").on("click keydown", function(event){
    if (event.type === "keydown" && event.key !== "Enter" && event.key !== " ") {
      return;
    }

    event.preventDefault();

    var $toggle = $(this);
    var $widget = $toggle.closest(".widget_product_categories");
    var isOpen = !$widget.hasClass("click");

    $widget.toggleClass("click");
    $toggle.attr("aria-expanded", isOpen ? "false" : "true");
    $widget.find("> .product-categories").stop(true, true).slideToggle(220);
  });

  $(".dt-menu-expand").click(function(event){
    event.preventDefault();
    if( $(this).hasClass("dt-mean-clicked") ){
   $(this).html('<i class="fa fa-plus"></i>');
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideUp(400);
      } else {
        $(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
      }
    } else {
     $(this).html('<i class="fa fa-minus"></i>');
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideDown(400);
      } else{
        $(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
      }
    }

    $(this).toggleClass("dt-mean-clicked");
    return false;
  });

});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
function process_slick_event(evt) {
if (typeof jQuery === 'undefined' || !jQuery.fn || !jQuery.fn.slick) {
return;
}

var sectionId = evt.target && evt.target.id ? "#" + evt.target.id + " " : "";
var _slick = jQuery(sectionId + ".home-slideshow .variable-width");
if (!_slick.length || _slick.children('.slick-list').length <= 1) {
return;
}

switch (evt.type) {
case "shopify:section:load":
if (!_slick.hasClass('slick-initialized')) {
_slick.slick({
dots: true,
slidesToScroll: 1,
autoplay: true,
fade: _slick.attr('data-slideshow-fade') === 'true',
autoplaySpeed: parseInt(_slick.attr('data-slideshow-speed'), 10) || 5000,
pauseOnHover: true
});
}
break;
case "shopify:section:unload":
if (_slick.hasClass('slick-initialized')) {
_slick.slick('unslick');
}
break;
}
}

document.addEventListener('shopify:section:load', process_slick_event);
document.addEventListener('shopify:section:unload', process_slick_event);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-type-18"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
var testimonialtype18 = $(".testimonial-car-18");
testimonialtype18.owlCarousel({
items:1,
loop:true,      
dots: true, 
nav:true,
//navContainer: ".testimonial-navigation",
//  navText: ['<a class="prev btn"><i class="icon-arrow-left" ></i></a>','<a class="next btn"><i class="icon-arrow-right" ></i></a>'],
//autoplay: true,
//autoplayTimeout: 3000,
responsive:{
0:{
items: 1
},
600:{
items:1
},
700:{
items:1
},

1000:{
items: 2
}
}
});
});

  } catch(e) { console.error(e); }
})();
})();
